import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Milestone = t.type({
  name: t.string,
  points: t.number,
  reachedAt: t.string
});
var FieldValue = t.type({
  name: t.string,
  value: t.string
});
var ReferralField = t.type({
  field: t.type({
    name: t.string,
    label: t.string
  })
});
export var ReferralProgress = t.type({
  fields: nullable(t.array(nullable(FieldValue))),
  campaign: t.type({
    id: t.string,
    slug: t.string,
    prospectFields: t.array(ReferralField),
    coverPhotoUrl: nullable(t.string),
    name: t.string
  }),
  submittedDate: t.string,
  currentStep: t.number,
  totalSteps: t.number,
  currentMilestone: t.type({
    name: t.string,
    reachedAt: t.string
  }),
  milestoneLog: t.array(Milestone)
});
export var Campaigns = t.type({
  campaigns: t.type({
    referralprogress: nullable(t.array(ReferralProgress))
  })
});
export var ReferralDashboardBlockConfig = S.struct({
  typename: S.literal('ReferralDashboardBlock'),
  id: S.string,
  hash: S.string
});